import JustValidate from 'just-validate';
import axios from 'axios';
import contactModal from './modal';
import consentSolution from '../../gdpr/consent-solution';
import getCity from '../core/select-city';

// Posthog
import ph from '../../analytics/posthog/posthog-client';

declare let contact_object: any;

// Consent Solution
const modConsentSolution = new consentSolution();

// Modal
const modal = new contactModal();

export default class contactOpenLasertag{

    protected elForm: string;

    protected elBtn: string;

    protected elFormSpin: string = 'bgdrop-spin';

    protected call_rest_api: string;

    protected get_city: any = null;

    constructor(
        elForm: string,
        elBtn: string
    ) {
        
        this.elForm = elForm;

        this.elBtn = elBtn;

        this.call_rest_api = contact_object.rest_urls.contact_open_lasertag;

        this.getContact();

    }
    
    // Get contact
    protected getContact() {
        
        const form = document.querySelector(this.elForm);

        if(form == null){
            
            return;

        }

        // Get City
        this.get_city = getCity('#field_city');

        // Validation
        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid bg-red-050 border border-red-700 focus:border-red-700 focus:ring-red-700 placeholder:text-gray-900',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1 fluid-text-sm text-red-700',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#field_name', [
            {
                rule: 'required',
                errorMessage: contact_object.error_messages.name_required,
            },
            {
                rule: 'minLength',
                value: 3,
            }
        ])
        .addField('#field_surname', [
            {
                rule: 'required',
                errorMessage: contact_object.error_messages.name_required,
            },
            {
                rule: 'minLength',
                value: 3,
            }
        ])
        .addField('#field_email', [
            {
                rule: 'required',
                errorMessage: contact_object.error_messages.email_required,
            },
            {
                rule: 'email',
                errorMessage: contact_object.error_messages.email_invalid,
            },
        ])
        .addField('#field_phone', [
            {
                rule: 'required',
                errorMessage: contact_object.error_messages.telephone_required,
            }
        ])
        .addField('#field_city', [
            {
                rule: 'required',
                errorMessage: contact_object.error_messages.city_required,
            }
        ])
        .addField('#field_message', [
            {
                rule: 'required',
                errorMessage: contact_object.error_messages.message_required,
            },
            {
                rule: 'minLength',
                errorMessage: contact_object.error_messages.message_short,
                value: 10,
            }
        ])
        .addField('#field_privacy_policy', [
            {
                rule: 'required',
                errorMessage: contact_object.error_messages.check_privacy_policy,
            }
        ])
        .onSuccess((ev) => {

            ev?.preventDefault();

            // Send form
            this.sendForm();
        
        });

    }
    
    // Send form
    protected sendForm(){
        
        const _that = this;

        // Form element
        const form = document.querySelector(this.elForm) as HTMLFormElement;

        // Button element
        const btn = document.querySelector(this.elBtn) as HTMLButtonElement | null;

        // Form data
        const data = new FormData(form);

        const select = document.querySelector('#field_city') as HTMLSelectElement;

        const city_label = select.options[select.selectedIndex].text as string;

        // Variables for Posthog
        const varsPostHog = {
            'name': data.get('field_name') as string,
            'surname': data.get('field_surname') as string,
            'email': data.get('field_email') as string,
            'city': city_label as string,
            'phone': data.get('phone_full') as string,
            'message':  data.get('field_message') as string,
        };

        // Prepare data
        const datastring = new URLSearchParams(data as any).toString();

        // Post data
        const post_data = {
            'fields': datastring
        };
        
        // Query string
        const queryString = new URLSearchParams(post_data).toString();
            
        // Init spin
        const spin = this.btnSpin();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(this.call_rest_api, queryString, {
            
            validateStatus: function (status) {
                
                return status == 200;
                
            }

        })
        .then(function (response:any){

            // Remove spin
            spin.remove();
                    
            // Remove the disabled attribute
            btn?.removeAttribute('disabled');

            //  Get status
            const responseStatus:boolean = response.data.status;

            // Append message to body
            document.body?.insertAdjacentHTML('beforeend', response.data.message);

            if(responseStatus == true){         

                // Consent solution
                modConsentSolution.getConsent(_that.elForm);

                // Send event to posthog
                ph.captureContactForm(
                    '[Contact] [B2B] Open Lasertag',
                    'B2B',
                    varsPostHog.name,
                    varsPostHog.surname,
                    varsPostHog.email,
                    varsPostHog.city,
                    varsPostHog.phone,
                    varsPostHog.message
                );

                // Open Modal
                modal.get('successModal', 'closeSuccessModal');

                // Reset city
                _that.get_city.clear(true);
                _that.get_city.clearOptions();

                // Form reset
                form.reset();

            }

        }).catch(function (error: any) {

            //  Get status
            const errorStatus = error.response.status;
                
            if(errorStatus != null && errorStatus == 201){
                
                // Error message
                const errorMessage = error.response.data.message;

                // Append message to body
                document.body?.insertAdjacentHTML('beforeend', errorMessage);

                // Open modal
                modal.get('errorModal', 'closeErrorModal');

            }

            // Remove spin
            spin.remove();
                    
            // Remove the disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

    /**
     * Create spin
     * @returns 
     */
    protected btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

}